import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';

import { setNavigate } from './navigate';


import { useProvider } from './context/MenuProvider'; // ajuste conforme seu caminho
import { doImmediateUpdate } from './pages/Update';

import AdminLayout from './layouts/AdminLayout';
import Painel from './pages/Home';
import Checkout from './pages/Checkout'
import RelatoriosHome from './components/Relatorios/Home';
import PagamentoList from './pages/PagamentoList';
import FluxoDeCaixa from './pages/FluxoDeCaixa';
import PagamentosLembrete from './pages/PagamentosLembrete';
import VendaDetails from './pages/VendaDetails';
import VendaList from './pages/VendaList';
import ProdutoList from './pages/ProdutoList';
import ProdutoForm from './components/Form/ProdutoForm';
import ProdutoListEstoque from './pages/ProdutoListEstoque';
import DespesaForm from './components/Form/DespesaForm';
import Feedback from './pages/Feedback';
import ClienteList from './pages/ClienteList';
import ImportarClientes from './pages/ImportarClientes';
import ClienteDetails from './pages/ClienteDetails';
import ChecagemCliente from './pages/ChecagemCliente';
import ClienteForm from './components/Form/ClienteForm';
import PerfilForm from './components/Form/PerfilForm';
import SiteForm from './components/Form/SiteForm';
import Gestao from './pages/Gestao';
import PainelLoja from './pages/PainelLoja';
import Captacao from './pages/Captacao';
import Agenda from './pages/Agenda';
import ArvoreGenealogica from './pages/ArvoreGenealogica';
import Equipe from './pages/Equipe';
import EquipeForm from './components/Form/EquipeForm';
import APN from './pages/APN';
import Prospectos from './pages/Prospectos';
import MeuMapa from './pages/MeuMapa';
import Slide from './pages/Slide';
import ListaSlide from './pages/ListaSlide';
import ApnForm from './components/Form/ApnForm';
import CategoriaList from './pages/CategoriaList';
import CategoriaForm from './components/Form/CategoriaForm';
import Atalhos from './components/Form/AtalhosForm';
import MarcaForm from './components/Form/MarcaForm';
import MarcaList from './pages/MarcaList';

//Config
import Config from './pages/Config';
import DeviceInfo from './components/Widgets/DeviceInfo'
import PushAdmin from './pages/PushAdmin';

// import ConviteMesclagem from './components/Config/ConviteMesclagem';
import Catalogos from './components/Config/Catalogos';
// import SincronizarProdutos from './components/Config/SincronizarProdutos';
// import PerfilForm from './components/Form/PerfilForm';
// import JurosForm from './components/Form/JurosForm';
import ConfiguracoesForm from './components/Form/ConfiguracoesForm';
import Backup from './pages/Backup';
import TemplateForm from './components/Form/TemplateForm';
import TemplateList from './pages/TemplateList';
import LinkPagamento from './pages/LinkPagamento';
// import SiteForm from './components/Form/SiteForm';
// import Entregas from './components/Config/Entregas';
import ConfigurarPagamentoOnline from './components/Form/ConfigurarPagamentoOnline';


import LojaLayout from './layouts/LojaLayout';
import Catalogo from './pages/Catalogo';
import Sync from './pages/Sync';
import ConectarWhatsApp from './pages/ConectarWhatsApp';

import Privacidade from './pages/Privacidade';
import Mensagens from './pages/Mensagens';

import Logout from './pages/Logout';
import Login from './pages/Login';
import ResetarSenha from './pages/ResetarSenha';
import ResetarSenhaConfirma from './pages/ResetarSenhaConfirma';

import InstalarApp from './pages/InstalarApp';
import AniversarioCliente from './pages/AniversarioCliente';

import SincronizarProdutos from './components/Config/SincronizarProdutos';
import ConviteMesclagem from './components/Config/ConviteMesclagem';
import GerenciarMetas from './pages/GerenciarMetas';


import { useLocation } from 'react-router-dom';

function RedirectTo({ de, para }) {
  const location = useLocation();

  // Normaliza de e para
  const from = de.trim().replace(/^\/|\/$/g, '');
  const to = para.trim().replace(/^\/|\/$/g, '');

  // Pega o que vem depois de /de/
  const pathAfter = location.pathname.replace(new RegExp(`^/${from}/`), '');

  return <Navigate to={`/${to}/${pathAfter}`} replace />;
}


function App() {
  const { site, home, loja, auth } = useProvider();
  //const isConsultaCarregada = useRef();
  
  useEffect(() => {
    // Verifica se há atualização assim que o app carregar
    doImmediateUpdate();
  }, []);
  
  if (!home) return;
  let rotaInicial = home;

  return (
    <Router>
      <NavigationSetter />
      <Routes>
        {/* Redireciona apenas se for exatamente na raiz */}
        {/*
          Redirecionamentos
        */}
        <Route path="/" element={<Navigate to={rotaInicial} />} />
        <Route path="/catalogo/*" element={<RedirectTo de={'catalogo'} para={`c`} />} />

        <Route path="/painel/*" element={<AdminLayout />}>
          <Route index element={<Painel />} />
          <Route path="meu-mapa" element={<MeuMapa />} />
          <Route path="dispositivos" element={<DeviceInfo />} />
          <Route path="apresentacoes" element={<ListaSlide />} />
          <Route path="slide/:id?" element={<Slide />} />
          <Route path="sync" element={<Sync />} />
          <Route path="loja" element={<PainelLoja />} />
          <Route path="privacy" element={<Privacidade />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="gestao/:tipo?" element={<Gestao />} />
          <Route path="perfil" element={<PerfilForm />} />
          <Route path="site" element={<SiteForm />} />
          <Route path="pagamento-online" element={<ConfigurarPagamentoOnline />} />
        </Route>
        <Route path="/integracao/*" element={<AdminLayout />}>
          <Route index element={<ConfigurarPagamentoOnline />} />
          <Route path="whatsapp" element={<ConectarWhatsApp />} />
          <Route path=":tipo/callback" element={<ConfigurarPagamentoOnline />} />
        </Route>
        
        <Route path="/config/*" element={<AdminLayout />}>
          <Route index element={<Config />} />
          <Route path="backup" element={<Backup />} />
          <Route path="funcoes" element={<ConfiguracoesForm />} />
          <Route path="templates/:tipo?" element={<TemplateList />} />
          <Route path="templates/novo/:tipo" element={<TemplateForm />} />
          <Route path="templates/editar/:id" element={<TemplateForm />} />
          <Route path="atalhos" element={<Atalhos />} />
          <Route path="push" element={<PushAdmin />} />
          <Route path="whatsapp" element={<PushAdmin />} />
        </Route>
        
        <Route path="/mensagens/*" element={<AdminLayout />}>
          <Route path="lista/:tipo?/:data?" element={<Mensagens />} />
          <Route index element={<Mensagens />} />
        </Route>
        
        <Route path="/marcas/*" element={<AdminLayout />}>
          <Route index element={<MarcaList />} />
          <Route path="novo" element={<MarcaForm />} />
          <Route path=":id" element={<MarcaForm />} />
        </Route>
        
        <Route path="/agenda/*" element={<AdminLayout />}>
          <Route index element={<Agenda />} />
          <Route path=":metodo" element={<Agenda />} />
        </Route>
        
        <Route path="/categorias/*" element={<AdminLayout />}>
          <Route path=":tipo?" element={<CategoriaList />} />
          <Route path="novo/:tipo?" element={<CategoriaForm />} />
          <Route path="editar/:id" element={<CategoriaForm />} />
        </Route>
        
        <Route path="/checkout/*" element={<AdminLayout />}>
          <Route index element={<Checkout />} />
          <Route path=":tipo" element={<Checkout />} />
        </Route>
        
        <Route path="/produtos/*" element={<AdminLayout />}>
          <Route index element={<ProdutoList />} />
          <Route path=":id" element={<ProdutoForm />} />
          <Route path="novo" element={<ProdutoForm />} />
          <Route path="atualizar-quantidade" element={<ProdutoListEstoque />} />
          <Route path="catalogos" element={<ProdutoListEstoque />} />
          <Route path="parceiros" element={<Catalogos />} />
          <Route path="convite" element={<ConviteMesclagem />} />
          <Route path="sincronizar" element={<SincronizarProdutos />} />
        </Route>
        
        <Route path="/vendas/*" element={<AdminLayout />}>
          <Route index element={<VendaList />} />
          <Route path=":id" element={<VendaDetails />} />
          <Route path=":id/:id_pagamento" element={<VendaDetails />} />
        </Route>
        
        <Route path="/clientes/*" element={<AdminLayout />}>
          <Route index element={<ClienteList />} />
          <Route path="aniversarios" element={<AniversarioCliente />} />
          <Route path="novo" element={<ClienteForm />} />
          <Route path="importar" element={<ImportarClientes />} />
          <Route path="checagem-de-inadimplencia" element={<ChecagemCliente />} />
          <Route path=":id/editar/:tipo?" element={<ClienteForm />} />
          <Route path=":id/:tipo?" element={<ClienteDetails />} />
        </Route>
        
        <Route path="/contatos/*" element={<AdminLayout />}>
          <Route index element={<ClienteList />} />
          <Route path=":id/:tipo?" element={<ClienteDetails />} />
          <Route path="novo/:tipo?" element={<ClienteForm />} />
        </Route>
        
        <Route path="/rede/*" element={<AdminLayout />}>
          <Route index element={<Captacao />} />
          <Route path="mapa" element={<ArvoreGenealogica />} />
          <Route path="prospectos" element={<Prospectos />} />
          <Route path="prospectos/:fase" element={<Prospectos />} />
          <Route path="equipe" element={<Equipe />} />
          <Route path="equipe/novo/:prospecto?/:retorno?" element={<EquipeForm />} />
          <Route path="equipe/:id/editar/:retorno?" element={<EquipeForm />} />
          <Route path="apn" element={<APN />} />
          <Route path="apn/novo/:prospecto?/:retorno?" element={<ApnForm />} />
          <Route path="apn/:id/editar" element={<ApnForm />} />
          <Route path=":tipo" element={<Captacao />} />
        </Route>
        
        <Route path="/despesas/*" element={<AdminLayout />}>
          <Route path="novo/:tipo?" element={<DespesaForm />} />
          <Route path="editar/:id/:tipo?" element={<DespesaForm />} />
        </Route>
        
        <Route path="/pagamentos/*" element={<AdminLayout />}>
          <Route index element={<PagamentoList />} />
          <Route path=":modelo/:tipo" element={<PagamentoList />} />
          <Route path="status/:tipo" element={<PagamentosLembrete />} />
          <Route path="fluxo-de-caixa" element={<FluxoDeCaixa />} />
        </Route>
        
        <Route path="/relatorios/*" element={<AdminLayout />}>
          <Route path="metas" element={<GerenciarMetas />} />
          <Route path=":tipo?" element={<RelatoriosHome />} />
          <Route path=":tipo/:modelo" element={<RelatoriosHome />} />
          <Route path=":tipo/:categoria/:modelo/:ano?" element={<RelatoriosHome />} />
        </Route>
        
        {/*
          Catálogo de produtos
        */}
        <Route path={`/c/${site?.empresa?.url?'':':slug/'}*`} element={<LojaLayout />}>
          <Route index element={<Catalogo />} />
          <Route path="privacy" element={<Privacidade />} />
        </Route>
        
        {/*
          Área de pagamentos para clientes
        */} 
        <Route path={`/p/:hash_token/*`} element={<LojaLayout />}>
          <Route index element={<LinkPagamento />} />
          <Route path=":tipo" element={<LinkPagamento />} />
        </Route>
        
        <Route path="/login" element={<Login />} />
        <Route path="/logout/:tipo?" element={<Logout />} />
        <Route path="/login/recuperar-senha" element={<ResetarSenha />} />
        <Route path="/login/criar-nova-senha/:uidb64/:token/" element={<ResetarSenhaConfirma />} />
        
        <Route path="/instalar-app/:indicacao?" element={<InstalarApp />} />

        {/* Mantém acesso livre às demais rotas */}
        <Route path="*" element={<div>Página não encontrada</div>} />
      </Routes>
    </Router>
  );
}

function NavigationSetter() {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);
  return null;
}

export default App;
